'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dependencies = require('../../dependencies');

var _checklistConstants = require('./checklistConstants');

/**
 * This is apparently required to help editor navigation around the checkbox.
 * I haven't noticed issues without it at this stage, but it was recommended by
 * the author of Draft JS in the following thread:
 * https://github.com/facebook/draft-js/issues/132
 */
exports.default = function (event, _ref) {
    var getEditorState = _ref.getEditorState;

    if (event.keyCode === _dependencies.KEY_CODES.LEFT_ARROW) {
        var editorState = getEditorState();
        var selection = editorState.getSelection();
        var startKey = selection.getStartKey();
        var blockType = editorState.getCurrentContent().getBlockForKey(startKey).getType();
        if (blockType === _checklistConstants.CHECKLIST_BLOCK_TYPE && selection.getStartOffset() === 0 && (selection.isCollapsed() || selection.getIsBackward())) {
            return _checklistConstants.COMMANDS.MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK;
        }
    }
}; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/keyBindingFn.js
// module id = 1725
// module chunks = 0